import { messagesEN } from './lib/intl/en-US';
import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const programId = '60c283f1f8b233677717a3d9';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
    },
};
